export const BROWSER_LIST: Record<string, string> = {
  Firefox: 'Mozilla Firefox',
  YaBrowser: 'Yandex Browser',
  OPR: 'Opera',
  Trident: 'Internet Explorer',
  Edge: 'Microsoft Edge',
  Chrome: 'Google Chrome',
  Safari: 'Safari',
};
